// API Configuration
const getApiUrl = () => {
  // Check if we're in the browser
  if (typeof window !== 'undefined') {
    // First try to get from window.__RUNTIME_CONFIG__
    if (window.__RUNTIME_CONFIG__?.API_URL) {
      return window.__RUNTIME_CONFIG__.API_URL;
    }
    // Then try to get from environment variable (works in development)
    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL;
    }
  }
  // Fallback to default
  return 'https://api.pravdasolutionsinc.com/api';
};

const API_URL = getApiUrl();

export const API_CONFIG = {
  baseUrl: API_URL,
  v1BaseUrl: `${API_URL}/v1`,
  csrfEndpoint: `${API_URL}/get_csrf_token/`,
}; 